import { httpsCallable, functions } from "/Users/michaeltucker/Documents/coding-projects/client/src/firebase.js";
import {
  getEmailAttributionFromStorage,
  isEmailAttributionTouch,
} from "./metaPixel";
import { getLocalDateKey } from "./dateTime";

const DEDUPE_STORAGE_PREFIX = "llp_email_reactivation_click";

function buildDedupeKey(touch = {}) {
  const campaignId = touch.mc_cid || touch.email_campaign_id || touch.utm_campaign || "unknown";
  const dayKey = getLocalDateKey();
  return `${DEDUPE_STORAGE_PREFIX}:${campaignId}:${dayKey}`;
}

function shouldSkipDuplicate(touch = {}) {
  try {
    const key = buildDedupeKey(touch);
    if (sessionStorage.getItem(key)) {
      return true;
    }
    sessionStorage.setItem(key, "1");
    return false;
  } catch (error) {
    return false;
  }
}

export async function persistEmailReactivationClickIfNeeded() {
  const touch = getEmailAttributionFromStorage();
  if (!touch || !isEmailAttributionTouch(touch)) {
    return { recorded: false, reason: "not_email_attribution" };
  }

  if (shouldSkipDuplicate(touch)) {
    return { recorded: false, reason: "duplicate_session" };
  }

  try {
    const callable = httpsCallable(functions, "recordEmailReactivationClick");
    const response = await callable({ touch });
    return response.data || { recorded: false };
  } catch (error) {
    console.warn("Failed to record email reactivation click:", error);
    return { recorded: false, reason: "callable_error" };
  }
}

export default persistEmailReactivationClickIfNeeded;
